(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fg-brands"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('.fg-brands');
    if (!root) return;
    var input = root.querySelector('#fg-brand-q');
    var feat = root.querySelector('[data-fg-feat]');
    var head = root.querySelector('[data-fg-all-h]');
    var empty = root.querySelector('[data-fg-empty]');
    var links = root.querySelectorAll('[data-brand]');
    var groups = root.querySelectorAll('.fg-brands__group');
    if (!input) return;

    var allLabel = head ? head.textContent : '';

    function filter() {
      var q = input.value.trim().toLowerCase();
      var hits = 0;

      links.forEach(function (a) {
        var match = !q || a.getAttribute('data-brand').indexOf(q) > -1;
        a.hidden = !match;
        if (match) hits++;
      });

      // A letter with nothing left under it should not keep its rule and letter.
      groups.forEach(function (g) {
        var any = g.querySelector('[data-brand]:not([hidden])');
        g.hidden = !any;
      });

      if (feat) feat.hidden = q.length > 0;
      if (empty) empty.hidden = hits > 0;
      if (head) head.textContent = q ? hits + ' match' : allLabel;
    }

    input.addEventListener('input', filter);
    // Escape clears rather than closing anything, which is what a search field
    // inside a page is expected to do.
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && input.value) {
        input.value = '';
        filter();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
